import React from 'react';
import { Header as CommonHeader } from '@chr/navisphereonline-shared-components';
import { ChrAuthClient, ChrDecodedJwt } from '@chr/common-web-ui-authentication/authClient';
import './header.scss';

interface IHeaderProps {
  appConfig?: AppConfig;
  authClient?: ChrAuthClient<ChrDecodedJwt>;
}
export class Header extends React.Component<IHeaderProps> {
  renderHeaders = () => {
    const {
      appConfig,
      authClient,
    } = this.props;

    return (
      <div data-test-id="common-header" >
        <CommonHeader appConfig={appConfig} authClient={authClient} />
      </div>
    );
  };

  render() {
    return this.renderHeaders();
  }
}
